import css from 'styled-jsx/css';
import { common } from '../../../theme/theme';

const style = css.global`
  .claim-timeline-add-contents {
    width: 420px;
    padding: 16px;
  }
  .claim-timeline-add-title {
    font-size: 16px;
    font-weight: 500;
    font-family: Arial, Helvetica, sans-serif;
    color: black;
    margin-bottom: 10px;
  }
  .claim-timeline-add-contents .label {
    font-size: 14px;
    margin-bottom: 6px;
  }
  .claim-timeline-add-contents .doc-comment-label {
    margin-top: 16px !important;
  }
  .claim-timeline-add-contents .comment-area {
    border: 1px solid #676767;
    border-radius: 4px;
    width: 100%;
    height: 110px;
    padding: 8px;
    font-size: 14px;
    resize: none;
  }
  .claim-timeline-add-contents .ant-upload.ant-upload-drag {
    background: #fafafa;
  }
  .claim-timeline-add-contents .claim-timeline-file-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 8px;
    padding: 6px 10px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    background: #fafafa;
    font-size: 13px;
  }
  .claim-timeline-add-contents .claim-timeline-file-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 8px;
  }
  .claim-timeline-add-contents .claim-timeline-file-remove {
    cursor: pointer;
    color: #888;
    font-size: 12px;
    padding: 0 6px;
  }
  .claim-timeline-add-contents :global(.submit-button) {
    margin-top: 16px;
    ${common.button}
    ${common.submitButton}
  }
  .claim-timeline-add-contents :global(.cancel-button) {
    ${common.button}
    ${common.cancelButton}
  }
`;

export default style;
